<template>
    <div class="setup-container">
        <div class="title">
            {{ $t("newWizartV2.uploadTrackingCodeToYourWebsite") }}
        </div>
        <div class="content">
            <InstallCode />
        </div>
    </div>
</template>

<script>
import JSIcon from "../fast-initialize/svg/JSIcon.vue";
import { mapState } from "vuex";
import InstallCode from "../fast-initialize/InstallCode.vue";

export default {
    name: "SetupPage",
    components: {
        JSIcon,
        InstallCode,
    },
    data() {
        return {};
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.markup); // languages.<insert language> to return html with markup
        },

        integrationScript() {
            const isProduction = process.env.PRODUCTION === "true";
            const hostname = this.site.customerClientAddress;
            const protocol = isProduction ? "https" : "http";
            const path = isProduction ? "static/js/loader.js" : "loader.js";
            const commandHandlerScript =
                `<script>window.supsis=window.supsis||function(){(supsis.q=supsis.q||[]).push(arguments)};supsis.l=+new Date;` +
                ["<", "/", "script>"].join("").concat("\n");
            return (
                `<!-- Start of SUPSIS Embed Code --> \n` +
                commandHandlerScript +
                `<script src=\"${protocol}://${hostname}/${path}\" type=\"text/javascript\" async defer>` +
                ["<", "/", "script>"].join("") +
                `\n<!-- End of SUPSIS Embed Code --> \n`
            );
        },
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            settingInitialized: (state) => state.setting.initialized,
        }),
    },
};
</script>

<style lang="scss" scoped>
.setup-container {
    .title {
        display: flex;
        justify-content: center;
        font-size: 24px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 20px;
    }

    .content {
        display: flex;
        justify-content: center;
        background-color: #f5f5f5;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    .content {
        overflow: hidden;
    }
    .title {
        text-align: center !important;
    }
}
</style>
